module.exports = __webpack_public_path__ + "static/google-play-49bc91f2a1933093b08bf84b29c2cfce.svg";